module.exports = __webpack_public_path__ + "static/media/checkbox.662dd18a.svg";